export const createLanguagesData = (languages) => {
  const data = {
    codes: {},
    default_language: null,
    languages: [],
  }
  languages
    .sort((a, b) => {
      if (a.position < b.position) {
        return -1;
      }
      if (a.position > b.position) {
        return 1;
      }
      return 0;
    })
    .forEach((language) => {
      const { code, direction, name } = language;
      data.codes[code] = '';
      data.languages.push({
        code,
        direction,
        title: name,
      })
    })
  return data;
}
